// extracted by mini-css-extract-plugin
export default {"link":"PinboardMessageItem_link__YGcuf"};